import { createFeaturedLinks } from "../../../Search/util/functions";
import { RESOURCE_TYPES } from "../../../util/constants";
import { selectAuthentication } from "../../authorization/slices";
import { formatQuickLinks } from "../../graphql/functions";
import {  search, updateReduxStore } from "../../graphql/slices/buckeye-link";
import { getBuckeyeLinkData } from "../enums";

const CONSTANTS = {
  get: getBuckeyeLinkData,
};

const get = `
    ${CONSTANTS.get} {
        items {
            title
            link
            snippet
            category
            subcategory
            tags
            identifier
            roles
        }
        featured {
            ${RESOURCE_TYPES.ACADEMIC}
            ${RESOURCE_TYPES.FINANCIAL}
            ${RESOURCE_TYPES.SOCIAL}
            ${RESOURCE_TYPES.WELLNESS}
            ${RESOURCE_TYPES.STUDENTS}
            ${RESOURCE_TYPES.STAFF_FAC}
            ${RESOURCE_TYPES.PARENTS_FAM}
        }
        affiliations {
          role
          label
        }
    }
`;

async function transformResponse(response = {}, { getState, dispatch }) {
  let res = {
    data: {
      items: [],
      featured: [],
      _quickLinks: [],
      quickLinks: [],
    }
  }
  let quickLinks
  const responseObj = response?.data?.[CONSTANTS.get];
  if (responseObj?.items?.length) {
    res.data.featured = createFeaturedLinks(
      responseObj?.featured ?? {},
      responseObj?.items ?? []
    );
    
    quickLinks = responseObj.items.filter(
      ({ tags = [], link, title }) =>
        title && link && tags?.includes("Quick Links")
    );
    res.data.items = responseObj.items
  }

  res.data._quickLinks = quickLinks
  const { roles = [] } = selectAuthentication(getState())
  quickLinks = formatQuickLinks({ links: quickLinks, roles: roles ?? [] })
  res.data.quickLinks = quickLinks
  const affiliations = (responseObj?.affiliations ?? []).map(({ role, label }) => {
    const linksAvailable = (res.data.items ?? []).filter(item => (item.roles ?? []).find(a => a === role))
    return {
      role,
      label,
      count: linksAvailable.length
    }
  }).filter(o => !!o.count)

  res.data.affiliations = affiliations

  dispatch(updateReduxStore({
    ...res,
    roles
  }))
  const query = getState()?.buckeyeLink?.query
  if(query?.length) {
    dispatch(search({ query }))
  }

  return res
}

const source = {
  CONSTANTS,
  QUERIES: {
    get,
  },
  transformResponse,
};

export default source;
